class CorporationZoneModel{
    sno?: number;
    count?: number;
    corporationZoneId?:number;
    name?:string;
    isActive?: boolean;

}
export default CorporationZoneModel;